import { ModelInstance, BaseModel, ToBackHook, ToFrontHook } from './util';
import { FootballStatistic } from './football-statistic';
import { GameTeamStatisticBase } from './game-team-statistic-base';

@ModelInstance({
  mappingFields: {
    team: 'team',
    competitor_team: 'competitorTeam'
  },
  relation: {
    team: FootballStatistic,
    competitorTeam: FootballStatistic
  }
})
export class FootballGameTeamStatistic extends BaseModel implements GameTeamStatisticBase {
  team: FootballStatistic;
  competitorTeam: FootballStatistic;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
